import { render } from "./MeusIcones.vue?vue&type=template&id=4b64c847&scoped=true"
import script from "./MeusIcones.vue?vue&type=script&lang=js"
export * from "./MeusIcones.vue?vue&type=script&lang=js"

import "./MeusIcones.vue?vue&type=style&index=0&id=4b64c847&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b64c847"]])

export default __exports__